import { handleRefreshToken, isTokenExpired } from "./accountHandler";
import getCookie from "./getToken";

const verifyToken = async () => {
  try {
    let token = getCookie("token");
    const refreshToken = getCookie("refreshToken");

    if (!token) {
      if (!refreshToken) return false;

      const newToken = await handleRefreshToken();
      if (!newToken) return false;

      return true;
    }

    if (isTokenExpired(token)) {
      if (!refreshToken) return false;

      const newToken = await handleRefreshToken();
      if (!newToken) return false;

      return true;
    }

    return true;
  } catch (err) {
    console.error("verifyToken error:", err);
    return false;
  }
};

export default verifyToken;
